/*global require, jQuery, $, Isotope*/

require('imagesloaded');
require('slick-carousel');
require('../node_modules/bootstrap/js/src/scrollspy');
window.Isotope = require('isotope-layout');

window.viewportsize = function () {
  var e = window;
  var a = 'inner';
  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return {
    width: e[a + 'Width'],
    height: e[a + 'Height'],
  };
};

jQuery.fn.error = function () {
  this.bind('error', arguments[0]);
  return this; // Needed for other methods to be able to chain off of yourFunctionName.
};

// init lightbox
$('a.lightbox').nivoLightbox({
  afterShowLightbox: function () {
    var src = $('.nivo-lightbox-content > iframe').attr('src');
    if (src) {
      src = src.replace('http://', 'https://');
    }

    // eslint-disable-next-line
    if (false/*!CookieAccept("m")*/ && src.indexOf('yout') > 0) {
      $('.nivo-lightbox-content > iframe').attr('src', '');
      return;
    }
    //if (viewportsize().width <= 991) {
    //  $('.nivo-lightbox-content > iframe').attr('src', src + '?autoplay=1&rel=0&disablekb=1').attr("allowfullscreen", "allowfullscreen");
    //} else {
    $('.nivo-lightbox-content > iframe').attr('src', src + '?autoplay=1&rel=0&disablekb=1');
    //}
  },
});

// init masonry galleries
var container = '.gallery-masonry-grid';
if ($(container).length) {
  $(container).imagesLoaded(function () {
    new Isotope(container, {
      itemSelector: '.grid-item',
      percentPosition: true,
    });
    if ($(container).hasClass('gallery-masonry-loading')) {
      $(container).removeClass('gallery-masonry-loading');
    }
  });
}

jQuery(function () {
  var $body = $('body');
  var $stickyPageNav = $('.sticky-page-nav-wrapper .sticky-page-nav');
  if ($stickyPageNav.length) {
    var centerActiveItem = function centerActiveItem() {
      var $activeItem = $('.page-nav-wrapper .page-nav-menu a.active').closest('li');

      if (!$activeItem.length) {
        $activeItem = $('.page-nav-wrapper .page-nav-menu li').first();
      }

      var wrapperWidth = $('.page-nav-wrapper .page-nav').outerWidth();
      var menuWidth = 0;

      $('.page-nav-wrapper .page-nav-menu li').each(function () {
        menuWidth += $(this).outerWidth();
      });

      if (menuWidth > wrapperWidth) {
        var prevWidth = 0;

        $activeItem.prevAll().each(function () {
          prevWidth += $(this).outerWidth();
        });

        var menuOffset = wrapperWidth / 2 - $activeItem.outerWidth() / 2 - prevWidth;

        $('.page-nav-wrapper .page-nav-menu').css({
          left: menuOffset,
        });
      }
    };

    var updatePageNav = function updatePageNav() {
      var $menu = $('.page-nav-wrapper .page-nav-menu');
      var $itemActive = $menu.find('a.active').parent();
      var $controlPrev = $('.page-nav-wrapper .page-nav-control.control-prev');
      var $controlNext = $('.page-nav-wrapper .page-nav-control.control-next');

      if ($itemActive.index() == 0) {
        $controlPrev.addClass('control-disabled');
      } else {
        if ($controlPrev.hasClass('control-disabled')) {
          $controlPrev.removeClass('control-disabled');
        }
      }

      //var target = $itemActive.find("a").attr('href');

      // if target exists
      //if ($(target).length > 0) {
      //  if (changehistory && history.replaceState) {
      //    clearTimeout(historytimer);
      //    historytimer = setTimeout(function () {
      //      history.replaceState(null, null, target);
      //    }, 50);
      //  }
      //}

      if ($itemActive.index() == $menu.find('li').length - 1) {
        $controlNext.addClass('control-disabled');
      } else {
        if ($controlNext.hasClass('control-disabled')) {
          $controlNext.removeClass('control-disabled');
        }
      }

      centerActiveItem();
    };

    // scrollspy on pagenav
    var scrollSpyTriggerOffset = $stickyPageNav.find('.page-nav').outerHeight() + $('header[role="banner"] .header').outerHeight();

    $('body').scrollspy({
      target: '.page-nav-menu',
      offset: scrollSpyTriggerOffset,
    });

    // recalculate offsets when scrolling
    $(window).on('scroll', function () {
      var nextTarget = $('.page-nav-wrapper .page-nav-menu > li > a.active').parent().next().next().find('.nav-link').attr('href');

      if (typeof nextTarget !== 'undefined') {
        if ($(nextTarget).length) {
          var triggerArea = 70;

          if (window.viewportsize().width <= 480) {
            triggerArea = 40;
          }

          // check if next target is within offset+triggerArea of top of window
          if ($(nextTarget).offset().top - scrollSpyTriggerOffset - $(window).scrollTop() < triggerArea) {
            if ($(nextTarget).hasClass('section-margin')) {
              // set new offset (increased by 60 - 30 on mobile)
              if (window.viewportsize().width > 480) {
                $body.data()['bs.scrollspy']._config.offset = scrollSpyTriggerOffset + 60;
              } else {
                $body.data()['bs.scrollspy']._config.offset = scrollSpyTriggerOffset + 30;
              }
            } else {
              // reset normal scrollspy offset
              $body.data()['bs.scrollspy']._config.offset = scrollSpyTriggerOffset;
            }
            // Force scrollspy to recalculate the offsets to targets
            $body.data()['bs.scrollspy']._process();
            // Refresh the scrollspy.
            $body.scrollspy('refresh');
          }
        }
      }
    });

    $(window).on('activate.bs.scrollspy', function () {
      updatePageNav();
    });

    // sticky (BS affix) logic
    setTimeout(function () {
      //var offsetHeight = $stickyPageNav.offset().top - $('header[role="banner"] .header').outerHeight();
      // set height on wrapping element to prevent page jumping (before affix event)
      //$stickyPageNav.on('affix.bs.affix', function () {
      //  var height = $(this).outerHeight();
      //  $(this).closest('.sticky-page-nav-wrapper').css('height', height).addClass('sticky-page-nav-affixed');
      //});
      //// reset height on wrapping element when bar is not affixed anymore (after affix-top event)
      //$stickyPageNav.on('affixed-top.bs.affix', function () {
      //  $(this).closest('.sticky-page-nav-wrapper').css('height', 'auto').removeClass('sticky-page-nav-affixed');
      //});
      //// initialize affix
      //$stickyPageNav.affix({
      //  offset: {
      //    top: offsetHeight
      //  }
      //});
    }, 1);
    // added timeout for more precise calculating of top offset

    // behavior for page-nav-controls
    $('.page-nav-control', $stickyPageNav).on('click', function (e) {
      e.preventDefault();

      if (!$(this).hasClass('control-disabled')) {
        var $menu = $(this).closest('.page-nav-wrapper').find('.page-nav-menu');
        var $itemActive = $menu.find('a.active').parent();

        if ($(this).hasClass('control-prev')) {
          // if not first item
          if ($itemActive.index() !== 0) {
            $itemActive.prev().prev().find('a').trigger('click');
          }
        } else if ($(this).hasClass('control-next')) {
          // if not last item
          if ($itemActive.index() !== $menu.find('li').length - 1) {
            $itemActive.next().next().find('a').trigger('click');
          }
        }
      }
    });

    setTimeout(function () {
      updatePageNav();
    }, 1);
    // added timeout for more precise calculating of menu width
  }

  $body.on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();
    var $this = $(this);
    var target = $(this).attr('href');
    if (target.length <= 1) {
      return;
    }

    var scrollOffset = $('header[role="banner"] .header').outerHeight();

    if ($(this).data('extra-scroll-offset')) {
      scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
    }

    // if target exists
    if ($(target).length > 0) {
      if ($('.sticky-page-nav-wrapper').length) {
        // check if target comes after page-nav - if true, increase offset
        var targetOffset = $(target).offset().top;
        var pageNavOffset = $('.sticky-page-nav-wrapper').offset().top;

        if (pageNavOffset > targetOffset) {
          // console.log('target comes before page-nav - do nothing');
        } else {
          // console.log('target comes after page-nav - increase offset');
          scrollOffset = (scrollOffset + $('.sticky-page-nav .page-nav').outerHeight()) - 5;
        }
      }

      // if target has section-margin class, increase offset
      if ($(target).hasClass('section-margin')) {
        if (window.viewportsize().width > 480) {
          scrollOffset = scrollOffset + 60;
        } else {
          scrollOffset = scrollOffset + 30;
        }
      }

      $('html, body').animate({
        scrollTop: $(target).stop().offset().top - scrollOffset,
      }, 1000, 'swing', function () {
        $this.blur();
      });
    }
  });

  // expandable content
  $('.expandable-content').each(function () {
    var $content = $(this).find('.expand-wrapper');
    var maxHeight = $content.data('max-height');
    var cssHeight = $content.css('maxHeight');

    if (!$(this).hasClass('expanded') && parseInt(cssHeight) == maxHeight + 1) {
      // Do nothing
    } else if ($content.outerHeight() >= maxHeight) {
      $content.css('maxHeight', maxHeight);
    } else {
      $(this).addClass('expanded');
    }
  });
  $('.expandable-content .expand-trigger').on('click', function () {
    var el = $(this);
    var elcontent = el.closest('.expandable-content');
    var elwrapper = elcontent.find('.expand-wrapper');
    var elfulldesc = el.closest('#full-description');
    var fulldesc = (elfulldesc.length == 1);
    if (fulldesc && elfulldesc.hasClass('nofade')) {
      elcontent.removeClass('expanded');
      elwrapper.css('maxHeight', elwrapper.data('max-height') + 'px');
      elfulldesc.removeClass('nofade');
      el.html(el.data('oldhtml'));
    } else {
      elcontent.addClass('expanded');
      elwrapper.css('maxHeight', '');
      if (fulldesc) {
        elcontent.removeClass('expanded');
        el.data('oldhtml', el.html());
        el.html('Minder lezen');
        elfulldesc.addClass('nofade');
      }
    }
  });

  $body.on('click', '.features-group-wrapper .expand-toggle', function () {
    $(this).closest('.features-group').toggleClass('expanded');
  });

  $('.destination-slider').slick({
    rows: 0,
    // div wrapping issue in v1.8.1 fix
    dots: false,
    arrows: true,
    prevArrow: '<a href="#" class="slider-control control-prev gtm-event" title="Vorige" data-gtm-event="Accommodation slider control: previous" rel="nofollow">&larr;</a>',
    nextArrow: '<a href="#" class="slider-control control-next gtm-event" title="Volgende" data-gtm-event="Accommodation slider control: next" rel="nofollow">&rarr;</a>',
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 500,
    cssEase: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
    customPaging: function customPaging(slick, index) {
      return '<a id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></a>';
    },
    responsive: [{
      breakpoint: 1201,
      settings: {
        slidesToShow: 5,
      },
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        dots: true,
      },
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        dots: true,
      },
    }, {
      breakpoint: 581,
      settings: {
        slidesToShow: 2,
        dots: true,
      },
    }, {
      breakpoint: 401,
      settings: {
        slidesToShow: 1,
        dots: true,
      },
    }],
  });

  $('.accommodation-slider:not(#vergelijkbaar)').slick({
    rows: 0,
    // div wrapping issue in v1.8.1 fix
    dots: true,
    arrows: true,
    prevArrow: '<a href="#" class="slider-control control-prev gtm-event" title="Vorige" data-gtm-event="Accommodation slider control: previous" rel="nofollow">&larr;</a>',
    nextArrow: '<a href="#" class="slider-control control-next gtm-event" title="Volgende" data-gtm-event="Accommodation slider control: next" rel="nofollow">&rarr;</a>',
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    cssEase: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
    // centerMode: true,
    // focusOnSelect: true,
    customPaging: function customPaging(slick, index) {
      return '<a id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></a>';
    },
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    }, {
      breakpoint: 675,
      settings: {
        slidesToShow: 1,
      },
    }],
  });

  // moving accommodation-slider when item that is not active is clicked
  $('.accommodation-slider:not(#vergelijkbaar)').on('click', '.slick-slide', function (e) {
    if (!$(this).hasClass('slick-active')) {
      e.preventDefault();
      var $slider = $(this).closest('.accommodation-slider');

      // check if slide is before or after active slides
      if ($(this).prevAll('.slick-active').length) {
        // console.log('element comes after active');
        $slider.slick('slickNext');
      } else {
        // console.log('element comes before active');
        $slider.slick('slickPrev');
      }
    }
  });
});
